<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        {{ editMode ? '编辑检测项目' : '新建检测项目' }}
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="save"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div>
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="form"
          :model="fd"
          :inline="true"
          label-suffix="："
          label-position="right"
          label-width="145px"
          class="c-form jx-jc-project-form"
          @submit.native.prevent
        >
          <el-row class="c-form__row">
            <el-col
              :span="24"
              class="c-form__col c-form__part-title"
            >
              项目基础信息
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="项目名称"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.xmmc"
                  maxlength="200"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="委托单位"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.wtdw"
                  maxlength="200"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="统一社会信用代码"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.shxydm"
                  maxlength="50"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="所属区域"
                class="c-form__item"
              >
                <select-address v-model="fd.qydm" />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                label="项目地址"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.xmdz"
                  maxlength="500"
                  placeholder="用于现场签到定位"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="联系人"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.lxr"
                  maxlength="50"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="联系电话"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.lxdh"
                  maxlength="30"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="设计单位"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.sjdw"
                  maxlength="200"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="施工/维保单位"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.sgdw"
                  maxlength="200"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="检测日期"
                required
                class="c-form__item"
              >
                <el-date-picker
                  v-model="detectionRange"
                  type="daterange"
                  value-format="timestamp"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="签到要求"
                required
                class="c-form__item"
              >
                <el-radio-group v-model="fd.qdyq">
                  <el-radio label="GPS">
                    GPS签到
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                label="检测依据"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.jcyj"
                  type="textarea"
                  :rows="2"
                  maxlength="1000"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                label="项目概述"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.xmgs"
                  type="textarea"
                  :rows="3"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col c-form__part-title"
            >
              合同信息
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="合同名称"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.htmc"
                  maxlength="200"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="合同编号"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.htbh"
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="合同有效期"
                required
                class="c-form__item"
              >
                <el-date-picker
                  v-model="contractRange"
                  type="daterange"
                  value-format="timestamp"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="合同金额（元）"
                class="c-form__item"
              >
                <el-input-number
                  v-model="fd.htje"
                  :min="0"
                  :precision="2"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                label="合同文件"
                required
                class="c-form__item"
              >
                <file-serve-upload
                  v-model="contractFileId"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  :data="uploadFd"
                  accept="application/pdf,application/msword,.doc,.docx"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="上传"
                    :auth-type="false"
                    type="primary"
                    native-type="button"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  />
                </file-serve-upload>
                <span class="u-text-warning">（支持 doc / docx / pdf，最大 10M）</span>
              </el-form-item>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col c-form__part-title"
            >
              检测建筑物概况
            </el-col>
            <el-col
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="竣工日期"
                required
                class="c-form__item"
              >
                <el-date-picker
                  v-model="fd.jzwgk.jgrq"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="建筑总面积（m²）"
                required
                class="c-form__item"
              >
                <el-input-number
                  v-model="fd.jzwgk.jzmj"
                  :min="0"
                  :precision="2"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="检测面积（m²）"
                required
                class="c-form__item"
              >
                <el-input-number
                  v-model="fd.jzwgk.jcmj"
                  :min="0"
                  :precision="2"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="建筑类别"
                required
                class="c-form__item"
              >
                <el-select
                  v-model="fd.jzwgk.jzlb"
                  clearable
                  placeholder="请选择建筑类别"
                >
                  <el-option
                    v-for="item in buildingTypeOptions"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="建筑楼层"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.jzwgk.jzlc"
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="建筑高度（m）"
                required
                class="c-form__item"
              >
                <el-input-number
                  v-model="fd.jzwgk.jzgd"
                  :min="0"
                  :precision="2"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="检测类型"
                required
                class="c-form__item"
              >
                <el-radio-group v-model="fd.jzwgk.jclx">
                  <el-radio
                    v-for="item in detectionTypeOptions"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="检测范围"
                required
                class="c-form__item"
              >
                <el-radio-group v-model="fd.jzwgk.jcfw">
                  <el-radio
                    v-for="item in detectionScopeOptions"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="竣工图纸情况"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.jzwgk.jgtztgqk"
                  maxlength="500"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="使用功能"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.jzwgk.sygn"
                  maxlength="500"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                label="检测部位"
                required
                class="c-form__item"
              >
                <el-input
                  v-model.trim="fd.jzwgk.jcbw"
                  maxlength="500"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col c-form__part-title jx-jc-section-title"
            >
              <span>建筑物信息</span>
              <k-button
                btn-text="新增建筑物"
                :auth-type="false"
                type="success"
                icon="kestrel-icon ki-plus"
                plain
                @click="addBuilding"
              />
            </el-col>
            <el-col
              v-for="(building, index) in fd.jzwList"
              :key="building.uuid || index"
              :span="24"
              class="jx-jc-building"
            >
              <div class="jx-jc-building__header">
                <strong>建筑物 {{ index + 1 }}</strong>
                <k-button
                  v-if="fd.jzwList.length > 1"
                  btn-text="删除"
                  :auth-type="false"
                  type="danger"
                  plain
                  @click="removeBuilding(index)"
                />
              </div>
              <el-row>
                <el-col
                  :span="12"
                  class="c-form__col"
                >
                  <el-form-item
                    label="建筑物名称"
                    required
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.jzwmc" />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  class="c-form__col"
                >
                  <el-form-item
                    label="建筑物地址"
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.jzwdz" />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="建筑面积（m²）"
                    class="c-form__item"
                  >
                    <el-input-number
                      v-model="building.jzmj"
                      :min="0"
                      :precision="2"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="检测面积（m²）"
                    class="c-form__item"
                  >
                    <el-input-number
                      v-model="building.jcmj"
                      :min="0"
                      :precision="2"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="建筑高度（m）"
                    class="c-form__item"
                  >
                    <el-input-number
                      v-model="building.gd"
                      :min="0"
                      :precision="2"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="地上层数"
                    required
                    class="c-form__item"
                  >
                    <el-input-number
                      v-model="building.dscs"
                      :min="1"
                      :precision="0"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="地下层数"
                    class="c-form__item"
                  >
                    <el-input-number
                      v-model="building.dxcs"
                      :min="0"
                      :precision="0"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="竣工日期"
                    class="c-form__item"
                  >
                    <el-date-picker
                      v-model="building.jgrq"
                      value-format="timestamp"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="建筑类别"
                    required
                    class="c-form__item"
                  >
                    <el-select
                      v-model="building.jzlb"
                      clearable
                      placeholder="请选择建筑类别"
                    >
                      <el-option
                        v-for="item in buildingTypeOptions"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="楼层说明"
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.jzlc" />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="使用功能"
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.sygn" />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="检测类型"
                    required
                    class="c-form__item"
                  >
                    <el-radio-group v-model="building.jclx">
                      <el-radio
                        v-for="item in detectionTypeOptions"
                        :key="item.id"
                        :label="item.id"
                      >
                        {{ item.text }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="检测范围"
                    required
                    class="c-form__item"
                  >
                    <el-radio-group v-model="building.jcfw">
                      <el-radio
                        v-for="item in detectionScopeOptions"
                        :key="item.id"
                        :label="item.id"
                      >
                        {{ item.text }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8"
                  class="c-form__col"
                >
                  <el-form-item
                    label="备注"
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.bz" />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  class="c-form__col"
                >
                  <el-form-item
                    label="检测部位"
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.jcbw" />
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  class="c-form__col"
                >
                  <el-form-item
                    label="竣工图纸情况"
                    class="c-form__item"
                  >
                    <el-input v-model.trim="building.jgtztgqk" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col c-form__part-title"
            >
              项目人员
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="项目负责人"
                required
                class="c-form__item"
              >
                <select-xm-user
                  v-model="fd.xmfzrDm"
                  role-code="JX-XMFZR"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="现场检测员"
                required
                class="c-form__item"
              >
                <select-xm-user
                  v-model="fd.jcyIds"
                  role-code="JX-JC"
                  multiple
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="审核人"
                required
                class="c-form__item"
              >
                <select-xm-user
                  v-model="fd.shrDm"
                  role-code="JX-SHR"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                label="批准人"
                required
                class="c-form__item"
              >
                <select-xm-user
                  v-model="fd.pzrDm"
                  role-code="JX-JSRY"
                  :show-dept="false"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="24"
              class="c-form__col c-form__part-title"
            >
              检测范围
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                label="设施系统"
                required
                class="c-form__item"
              >
                <el-checkbox-group
                  v-model="fd.ssxtIds"
                  class="jx-jc-facilities"
                >
                  <el-checkbox
                    v-for="item in facilities"
                    :key="item.ssxtxh"
                    :label="item.ssxtxh"
                  >
                    {{ item.ssxtmc }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { projectService } from './project.service.js';

const emptyBuilding = () => ({
  jzwmc: '',
  jzwdz: '',
  jzmj: null,
  jcmj: null,
  gd: null,
  dscs: null,
  dxcs: 0,
  jgrq: null,
  jgtztgqk: '',
  jzlb: '',
  jzlc: '',
  jclx: '',
  jcfw: '',
  jcbw: '',
  sygn: '',
  bz: ''
});
const emptyBuildingOverview = () => ({
  jgrq: null,
  jgtztgqk: '',
  jzmj: null,
  jcmj: null,
  jzlb: '',
  jzlc: '',
  jzgd: null,
  jclx: '',
  jcfw: '',
  jcbw: '',
  sygn: ''
});
const emptyProject = () => ({
  xmmc: '',
  xmdz: '',
  qydm: '',
  xmgs: '',
  wtdw: '',
  lxr: '',
  lxdh: '',
  shxydm: '',
  sjdw: '',
  sgdw: '',
  jcyj: '《建筑消防设施检测技术规范》GB/T 44481—2024',
  qdyq: 'GPS',
  xmfzrDm: '',
  shrDm: '',
  pzrDm: '',
  htbh: '',
  htmc: '',
  htje: null,
  jzwgk: emptyBuildingOverview(),
  jzwList: [emptyBuilding()],
  jcyIds: [],
  ssxtIds: []
});

export default {
  name: 'JxxfJcProjectForm',
  data () {
    return {
      loading: false,
      editMode: false,
      facilities: [],
      detectionRange: [],
      contractRange: [],
      contractFileId: '',
      uploadFd: { meta: [{ key: 'type', value: 'jxxfjcht' }] },
      fd: emptyProject()
    };
  },
  computed: {
    buildingTypeOptions () { return (this.$store.state.apiEnums.iffApi || {}).IFF_JZLB_JC || []; },
    detectionTypeOptions () { return (this.$store.state.apiEnums.iffApi || {}).IFF_JCLX || []; },
    detectionScopeOptions () { return (this.$store.state.apiEnums.iffApi || {}).IFF_JCFWLX || []; }
  },
  methods: {
    addBuilding () { this.fd.jzwList.push(emptyBuilding()); },
    removeBuilding (index) { this.fd.jzwList.splice(index, 1); },
    normalizeFileId (value) {
      const file = Array.isArray(value) ? value[0] : value;
      return file && typeof file === 'object' ? (file.id || file.fileId) : file;
    },
    validateForm () {
      if (!this.fd.xmmc || !this.fd.wtdw || !this.fd.shxydm || !this.fd.xmdz || !this.fd.jcyj || !this.detectionRange.length) return '请完整填写项目基础信息';
      if (!this.fd.htmc || !this.fd.htbh || !this.contractRange.length || !this.normalizeFileId(this.contractFileId)) return '请完整填写合同信息并上传合同文件';
      const overview = this.fd.jzwgk || {};
      if (!overview.jgrq || overview.jzmj == null || overview.jcmj == null || !overview.jzlb || !overview.jzlc || overview.jzgd == null ||
        !overview.jclx || !overview.jcfw || !overview.jgtztgqk || !overview.jcbw || !overview.sygn) return '请完整填写检测建筑物概况';
      if (!this.fd.jzwList.length || this.fd.jzwList.some(item => !item.jzwmc)) return '请完整填写建筑物名称';
      if (this.fd.jzwList.some(item => item.dscs == null || item.dscs < 1)) return '请填写建筑物地上层数，且不得小于 1 层';
      if (this.fd.jzwList.some(item => !item.jzlb)) return '请选择建筑物类别';
      if (this.fd.jzwList.some(item => !item.jclx || !item.jcfw)) return '请完整选择建筑物的检测类型和检测范围';
      if (!this.fd.xmfzrDm || !this.fd.jcyIds.length || !this.fd.shrDm || !this.fd.pzrDm) return '请完整选择项目人员';
      if (!this.fd.ssxtIds.length) return '请至少选择一个设施系统';
      return null;
    },
    save () {
      const message = this.validateForm();
      if (message) { this.$message.warning(message); return; }
      const payload = Object.assign({}, this.fd, {
        jcrqq: this.detectionRange[0],
        jcrqz: this.detectionRange[1],
        htksrq: this.contractRange[0],
        htjsrq: this.contractRange[1],
        htfjid: this.normalizeFileId(this.contractFileId)
      });
      this.loading = true;
      const request = this.editMode ? projectService.update(this.$route.params.xmId, payload) : projectService.create(payload);
      request.then(() => {
        this.$message.success(this.editMode ? '项目修改成功' : '项目创建成功');
        this.closeNavTabAndTo({ name: 'jxxfJcProjectIndex' });
      }).finally(() => { this.loading = false; });
    },
    loadFacilities () { return projectService.facilities().then(rsp => { this.facilities = rsp.data || []; }); },
    loadProject () {
      this.loading = true;
      projectService.detail(this.$route.params.xmId).then(rsp => {
        const data = rsp.data || {};
        this.contractFileId = data.htfjid || '';
        const formData = Object.assign({}, data);
        delete formData.htfjid;
        this.fd = Object.assign(emptyProject(), formData, {
          jzwgk: Object.assign(emptyBuildingOverview(), data.jzwgk || {}),
          jzwList: data.jzwList && data.jzwList.length ? data.jzwList : [emptyBuilding()],
          jcyIds: data.jcyIds || [],
          ssxtIds: (data.ssxtList || []).map(item => item.ssxtxh)
        });
        this.detectionRange = [data.jcrqq, data.jcrqz];
        this.contractRange = [data.htksrq, data.htjsrq];
      }).finally(() => { this.loading = false; });
    }
  },
  created () {
    this.loadFacilities();
    if (this.$route.params.xmId) { this.editMode = true; this.loadProject(); }
  }
};
</script>

<style lang="scss">
.jx-jc-project-form {
  .el-input, .el-input-number, .el-select, .el-date-editor { width: 100%; }
  .jx-jc-section-title { display: flex; align-items: center; justify-content: space-between; }
  .jx-jc-building { padding: 12px 0; border-bottom: 1px solid #ebeef5; }
  .jx-jc-building__header { display: flex; min-height: 36px; align-items: center; justify-content: space-between; padding: 0 12px; }
  .jx-jc-facilities {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    column-gap: 10px;
    row-gap: 0;

    .el-checkbox {
      margin-right: 0;
      line-height: 26px;
    }
  }
}
</style>
